import React from "react";
import privacyHeroShield from "../../assets/images/privacy/privacy-hero-shield.png";

/** Default shield graphic for the Privacy Policy hero. */
export default function PrivacyHeroVisual() {
  return (
    <div className="hub-privacy-hero__visual" aria-hidden>
      <img
        src={privacyHeroShield}
        alt=""
        className="hub-privacy-hero__visual-img"
        width={492}
        height={181}
        decoding="async"
      />
    </div>
  );
}
